import React, {FC} from 'react';
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { SupplierBookingCheckInSearchCriteria } from "../../../types/model/criteria/booking/SupplierBookingCheckInSearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  SortFilterContainer,
  SortFilterItemContainer,
  SortFilterRowContainer
} from "../../common/reports/sortFilter";
import {
  sortByFields,
  SupplierBookingCheckInSortByType,
  SupplierBookingCheckInSortParams
} from "../../../types/model/params/sortParams/SupplierBookingCheckInSortParams";
import {
  BoundSortSelect,
  BoundDataDrivenAutocomplete,
  BoundTextInput
} from "../../common/inputs/boundInputs";

export interface SupplierBookingCheckInSearchParams extends SupplierBookingCheckInSearchCriteria, SupplierBookingCheckInSortParams, PageableParams, BoundSearchQuery {}

export interface SupplierBookingCheckInSortFilterProps {
  query: SupplierBookingCheckInSearchParams;
  onChange: (newQuery: SupplierBookingCheckInSearchParams) => void;
}

const SupplierBookingCheckInSortFilter: FC<SupplierBookingCheckInSortFilterProps> = ({
  query,
  onChange
}) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<SupplierBookingCheckInSearchParams>
          label="Location"
          requestUrl={optionsEndpoints.supplier.location}
          name="locationId"
          value={query?.locationId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundDataDrivenAutocomplete<SupplierBookingCheckInSearchParams>
          label="Buyer"
          requestUrl={optionsEndpoints.supplier.account.buyer}
          name="buyerAccountId"
          value={query?.buyerAccountId}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
    <SortFilterRowContainer>
      <SortFilterItemContainer>
        <BoundTextInput<SupplierBookingCheckInSearchParams>
          label="Booking Number"
          name="bookingNumber"
          value={query?.bookingNumber}
          onChange={onChange}
        />
      </SortFilterItemContainer>
      <SortFilterItemContainer>
        <BoundSortSelect<SupplierBookingCheckInSearchParams, SupplierBookingCheckInSortByType>
          query={query}
          defaultSortBy="START_DATE"
          defaultSortDir="desc"
          sortByFields={sortByFields}
          onChange={onChange}
        />
      </SortFilterItemContainer>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { SupplierBookingCheckInSortFilter };